import { checkoutAttemptContext } from './checkoutContext';
import {
  deliveryDetails,
  normalizeDeliveryAddress,
  sameDeliveryDestination,
} from './deliveryAddress';

export const hasDeliveryRevision = (value) =>
  typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);

export const requiresCheckoutResolution = (checkout, mode) =>
  mode === 'delivery' ||
  !!checkout?.recovered ||
  hasDeliveryRevision(checkout?.delivery_revision);

export const checkoutRequiresResolution = (state) =>
  requiresCheckoutResolution(
    state.order?.checkoutData,
    state.order?.type?.value
  );

export function deliveryCheckoutMatches(state) {
  if (!checkoutRequiresResolution(state)) return true;
  const binding = state.order.checkoutDeliveryBinding;
  return (
    !!binding &&
    !['pending', 'blocked', 'error'].includes(
      state.order.checkoutDeliveryResult?.status
    ) &&
    state.order.checkoutData?.id === binding.id &&
    state.order.checkoutData?.delivery_revision === binding.revision &&
    hasDeliveryRevision(binding.revision) &&
    checkoutAttemptContext(state, binding.destination) === binding.context
  );
}

export function sameAcknowledgedDestination(expected, actual) {
  const left = normalizeDeliveryAddress(expected);
  const right = normalizeDeliveryAddress(actual);
  return (
    !!left &&
    !!right &&
    sameDeliveryDestination(left, right) &&
    JSON.stringify(deliveryDetails(left.addition)) ===
      JSON.stringify(deliveryDetails(right.addition))
  );
}

export function revisionParameter(checkout) {
  return hasDeliveryRevision(checkout?.delivery_revision)
    ? { expected_delivery_revision: checkout.delivery_revision }
    : {};
}

export const paymentResolutionBlocksMutation = (result) =>
  result?.operation_pending ||
  result?.synchronization_allowed === false ||
  !['unpaid', 'action_required', 'canceled', 'expired'].includes(result?.state);
